const initialState = [];

const reductions = {
  NEW_FIELD_MAPPING: function (state, action) {
    const foundFieldMapping = state.find((c) => c.id === action.payload.id);
    if (foundFieldMapping) {
      return state;
    }
    return state.concat(action.payload);
  },
  UPDATE_FIELD_MAPPING: function (state, action) {
    let fieldFound = false;
    const newFieldMappings = state.map((field) => {
      if (field.id === action.payload.id) {
        fieldFound = true;
        return action.payload;
      }
      return field;
    });
    if (!fieldFound) {
      return newFieldMappings.concat(action.payload);
    }
    return newFieldMappings;
  },
  DELETE_FIELD_MAPPING: function (state, action) {
    return state.filter((c) => c.id !== action.payload.id);
  },
  NEW_FIELD_MAPPINGS: function (state, action) {
    return state.concat(action.payload);
  },
};

const fieldMappingsReducer = (state = initialState, action) => {
  if (action && action.type && reductions[action.type]) {
    return reductions[action.type](state, action);
  }
  return state;
};

export default fieldMappingsReducer;
